import React from 'react'
import { hot } from 'react-hot-loader'
import { LocalisationProvider } from '@yoti-web-share/localisation'
import ErrorBoundary from '../ErrorBoundary'
import ParametersProvider from '../../providers/Parameters'
import ShareDetailsProvider from '../../providers/ShareDetails'
import LearnMore from '../LearnMore'

const App = () => (
  <LocalisationProvider>
    <ErrorBoundary>
      <ParametersProvider>
        <ShareDetailsProvider>
          <LearnMore />
        </ShareDetailsProvider>
      </ParametersProvider>
    </ErrorBoundary>
  </LocalisationProvider>
)

export default hot(module)(App)
